/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/Util" />
import * as React from "react";

export function renderTooltipWithBreaks(text: string) {
    return (
        <div>
            {text.split("\n").map((str, index) => (
                <p key={index}>{str}</p>
            ))}
        </div>
    );
}
